import React from 'react';

import { eventEmitter } from './services';
import {
    Toast,
    Loading,
} from './components';

class Container extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            loadingText: '',
            snackbarOpen: false,
            snackbarText: '',
            snackbarType: '',
        };
    }

    async componentWillMount() {
        eventEmitter.subscribe('toast', data => this.showToast(data));
        eventEmitter.subscribe('loading', data => this.showLoading(data));
        eventEmitter.subscribe('go-login', () => this.props.history.push('/login'));
        eventEmitter.subscribe('no-access', () => this.props.history.push('/error/403'));
    }

    componentDidCatch(error, info) {
        // this.props.history.push('/error/500');
    }

    showToast({ message, type }) {
        this.setState({ snackbarOpen: true, snackbarText: message, snackbarType: type });
    }

    showLoading({ show, text }) {
        this.setState({ loading: show, loadingText: text });
    }

    render() {
        const {
            loading,
            loadingText,
            snackbarOpen,
            snackbarText,
            snackbarType,
        } = this.state;

        const {
            children,
        } = this.props;

        return (
            <div>
                {loading && <Loading text={loadingText} />}
                {children}
                <Toast
                    onRequestClose={() => this.setState({ snackbarOpen: false })}
                    snackbarOpen={snackbarOpen}
                    snackbarText={snackbarText}
                    snackbarType={snackbarType}
                    onActionClick={() => this.setState({ snackbarOpen: false })}
                />
            </div>
        );
    }
}

export default Container;
